import styled from "styled-components";

const InputWrapper = styled.input`
  border: 1px solid ${props => props.theme.borderLightGrey};
  color: ${props => props.theme.darkGrey};
  padding: ${props => props.theme.padding12};
  width: inherit;
`;

export default InputWrapper;
